import * as React from "react";
import Icon from "../../types/Icon.interface";

const IconInfo: React.FC<Icon> = (props: Icon) => {
  const { color = "#002D5A", size = 20, className, style } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      className={className}
      style={style}
    >
      <g fill="none" fillRule="evenodd">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={size / 2}
          fill={color}
          style={{ stroke: "none" }}
        />
        <path
          style={{ stroke: "none" }}
          fill="#F1F3F5"
          d="M10.308 5.364c-.66 0-1.154-.507-1.154-1.182 0-.675.494-1.182 1.154-1.182.659 0 1.154.507 1.154 1.182 0 .675-.495 1.182-1.154 1.182zM8 16v-.411c.385-.411 1.538-.822 1.538-.822V8.19C9.154 7.779 8 7.368 8 7.368v-.823h3.462v8.222s1.153.41 1.538.822V16H8z"
        />
      </g>
    </svg>
  );
};

export default IconInfo;
